import { ajaxURL, loginRedirect, loginPage ,googleRecaptchaSiteKey} from './variables.js';
window.addEventListener('DOMContentLoaded', (event) => {
  
    let noSearchStr = 'Es gibt keine Daten. Bitte setzen Sie die Filter anders';
    const ajaxUrl = ajaxURL;
    let filter = {};
    let prevPriceFrom = 0;
    let prevPriceTo = 0;
    let prevPostalCodeFrom = 0;
    let prevPostalCodeTo = 0;
    let delay = 1000;
    // timerids
    let timerIdPriceFrom = '';
    let timerIdPriceTo = '';
    let timerIdPostalCodeFrom = '';
    let timerIdPostalCodeTo = '';


    //if .price__grid-data--no-results is present add text to it noSearchStr
    // if($('.price__grid-data--no-results').length){
    //     $('.price__grid-data--no-results').text(noSearchStr);
    // }
    if(document.querySelector('.okopunkt-listings-dropdown .price__grid-data--no-results')){
        document.querySelector('.okopunkt-listings-dropdown .price__grid-data--no-results').textContent = noSearchStr;
    }

  

 
    if( document.querySelector('.okopunkt-listings-dropdown #price__grid-type')){
        document.querySelector('.okopunkt-listings-dropdown #price__grid-type').addEventListener('change', function(){
            let value = this.value;
            filter.type = value;
            // console.log(filter);
            ajaxCall(filter);
        });
    }



    if(document.querySelector('.okopunkt-listings-dropdown #price__grid-post')){
        document.querySelector('.okopunkt-listings-dropdown #price__grid-post').addEventListener('change', function(){
            let value = this.value;
            filter.postalcode = value;
            // console.log(filter);
            ajaxCall(filter);
        });
    }




    // ajax call
    function ajaxCall(filter){
        if(document.querySelector('.okopunkt-listings-dropdown #price__grid-container')){
            let state = document.querySelector('.okopunkt-listings-dropdown #price__grid-container').dataset.state;
            if(state){
                filter.state = state;
            }
        }

        if(!filter.postalcode || !filter.type){
            console.log('filter.postalcode or filter.type not set');
            //if .price__grid-data--no-results is not present add text to it noSearchStr
            if(!document.querySelector('.okopunkt-listings-dropdown .price__grid-data--no-results')){
                // empty #price__grid-data
                document.querySelector('.okopunkt-listings-dropdown #price__grid-data').innerHTML = '';
                let div = document.createElement('div');
                div.classList.add('price__grid-data--no-results');
                div.textContent = noSearchStr;
                document.querySelector('.okopunkt-listings-dropdown #price__grid-data').appendChild(div);
            }
            
           
            return;
        }





        let form = new FormData();
        form.append('action', 'ecopoints_filter');
        form.append('filter', JSON.stringify(filter));
        //  hide #price__grid-data , add class .loading to #price__grid-container 
        document.querySelector('.okopunkt-listings-dropdown #price__grid-data').style.display = 'none';

        document.querySelector('.okopunkt-listings-dropdown #price__grid-container').classList.add('loading');
        	



        fetch(ajaxUrl, {
            method: 'POST',
            body: form
        })
        .then(response => response.json())
        .then(data => {
            console.log(data);
            // remove class .loading from #price__grid-container
            document.querySelector('.okopunkt-listings-dropdown #price__grid-container').classList.remove('loading');
            // if data.output is empty
            if(data.output == "no results"){
               // empty #price__grid-data
                document.querySelector('.okopunkt-listings-dropdown #price__grid-data').innerHTML = '';
                let div = document.createElement('div');
                div.classList.add('price__grid-data--no-results');
                div.textContent = noSearchStr;
                document.querySelector('.okopunkt-listings-dropdown #price__grid-data').appendChild(div);
                // unhide #price__grid-data
                document.querySelector('.okopunkt-listings-dropdown #price__grid-data').style.display = 'block';
            }
            else{
                // add response to #price__grid-data
                document.querySelector('.okopunkt-listings-dropdown #price__grid-data').innerHTML = data.output;
                // unhide #price__grid-data
                document.querySelector('.okopunkt-listings-dropdown #price__grid-data').style.display = 'block';
            }

        })
        

    }

});